import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6046b0a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-phone-container" }

import router from "@/router";
import {AppConfig} from "@/config";
import {isShowMenuPhone, isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainHeaderMenuPhone',
  setup(__props) {

const selectButton = (button: string) => {
  router.push(button)
  isShowMenuPhone.value = !isShowMenuPhone.value;
}
const onQrCodeClick = () => {
  isShowQrCodeDialog.value = true
}
const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      text: "",
      class: "text-second-title menu-phone-item margin-top-60",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (selectButton(_unref(AppConfig).route_home)))
    }, {
      default: _withCtx(() => [
        _createTextVNode("首页")
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_button, {
      text: "",
      class: "text-second-title menu-phone-item",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (selectButton(_unref(AppConfig).route_cpCredit)))
    }, {
      default: _withCtx(() => [
        _createTextVNode("企业信用维护")
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_button, {
      text: "",
      class: "text-second-title menu-phone-item",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (selectButton(_unref(AppConfig).route_about)))
    }, {
      default: _withCtx(() => [
        _createTextVNode("关于我们 ")
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_button, {
      text: "",
      class: "text-second-title menu-phone-item",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (onPhoneClick()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("电话：13167540356")
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_el_button, {
      text: "",
      class: "text-second-title menu-phone-item",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (onQrCodeClick()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("微信扫码联系")
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider)
  ]))
}
}

})